import { useState } from 'react'
import { useRouter } from 'next/router'
import Image from 'next/legacy/image'
import cn from 'classnames'
// Components
import AskAboutPuppyModal from './lib/AskAboutPuppyModal'
import Button from '../newButton/Button'
import styles from './MobileKeypad.module.scss'
// Handlers
import { handleReserve } from './lib/handlers'

export default function MobileActions({
  dog,
  salePrice,
  loading,
  dataApplication,
}) {
  const router = useRouter()
  const [openModal, setOpenModal] = useState(false)

  if (loading) {
    return null
  }

  if (!dog?.isAvailable) {
    return (
      <div className={cn(styles.keypad, styles.notAvailable)}>
        <Image
          width={80}
          height={80}
          src="/puppy/family-house.svg"
          alt="family house"
        />
        <div className={styles.text}>This Puppy Has Found A Forever Home.</div>
        <Button
          title="Browse Others"
          onClick={() => router.push('/search')}
          theme={['short', 'pink-solid']}
          style={{ width: '200px', height: '40px' }}
        />
      </div>
    )
  }

  return (
    <div className={cn(styles.chatOnly, styles.keypad)}>
      <Button
        title="Ask about me"
        onClick={() => setOpenModal(true)}
        theme={['short', 'black']}
        leftImage="/puppy/ask-about-puppy.svg"
        style={{ padding: '0' }}
      />
      {salePrice !== isNaN && salePrice > 0 && (
        <Button
          title="Take me home"
          onClick={() => handleReserve(dog, router, dataApplication)}
          theme={['short', 'green-solid']}
        />
      )}
      <AskAboutPuppyModal
        dataPuppy={dog}
        isOpen={openModal}
        close={() => setOpenModal(false)}
      />
    </div>
  )
}
